import Alpine from "alpinejs";

Alpine.store('validation',new Map());

export default function setValidationErrors(errors) {
    const v = new Map();

    if (errors) {
        for (const [key, value] of Object.entries(errors)) {
            v.set(key, value);
        }
    }

    Alpine.store('validation',v);
}
